import { render, staticRenderFns } from "./InvoiceItemsDialogComponent.vue?vue&type=template&id=3c005e17&"
import script from "./InvoiceItemsDialogComponent.vue?vue&type=script&lang=js&"
export * from "./InvoiceItemsDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports